import { render, staticRenderFns } from "./PluginSlot.vue?vue&type=template&id=e424e504&"
import script from "./PluginSlot.vue?vue&type=script&lang=js&"
export * from "./PluginSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports